import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Loader2 } from "lucide-react";

export const GptAnswer = ({ state, testid }) => {
  if (!state) return null;
  if (state.loading) {
    return (
      <div className="mt-4 flex items-center gap-2 text-sm text-cyan-300" data-testid={`${testid}-loading`}>
        <Loader2 className="w-4 h-4 animate-spin" /> GPT réfléchit… (30 s à 3 min selon la question)
      </div>
    );
  }
  if (state.error) {
    return <div className="mt-4 text-sm text-red-400" data-testid={`${testid}-error`}>Erreur : {state.error}</div>;
  }
  return (
    <div
      className="mt-4 border-t border-slate-700 pt-4 text-sm text-slate-200 leading-relaxed prose prose-invert prose-sm max-w-none
        [&_table]:w-full [&_table]:text-xs [&_th]:text-left [&_th]:text-slate-400 [&_th]:border-b [&_th]:border-slate-700 [&_th]:py-1 [&_th]:pr-2
        [&_td]:border-b [&_td]:border-slate-800 [&_td]:py-1 [&_td]:pr-2 [&_h2]:text-base [&_h3]:text-sm [&_strong]:text-slate-50"
      data-testid={`${testid}-result`}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{state.reply}</ReactMarkdown>
    </div>
  );
};
